import React, { useRef, useState } from "react";

import CustomButton from '../CustomButton/CustomButton';

import { VideoSectionContainer } from "./VideoSection.style";

const VideoSection = ({
    subheading = "Who We Are",
    title = "Welcome to",
    highlight = "Subjects Master",
    tagline = "Built for Teachers. Loved by Students.",
    description = [],
    buttonText = "Learn More",
    buttonLink = "/learn-more",
    introImage,
    videoIcon,
    videoSrc,
}) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    const handleVideoClick = () => {
        setIsPlaying(true);
        // start playback as soon as the video element mounts
        // small timeout ensures ref is attached; safe in most cases
        setTimeout(() => {
            if (videoRef.current && typeof videoRef.current.play === "function") {
                videoRef.current.play().catch(() => {
                    // play might be blocked by browser autoplay policies; user can press play
                });
            }
        }, 50);
    };

    return (
        <VideoSectionContainer className="video_section_wrappers">
            <div className="mygrid-container">
                <div className="mygrid-row">
                    {/* Left Content */}
                    <div className="mygrid-col-lg-6 mygrid-col-md-12">
                        <div className="video_content">
                            {subheading && <h5 className="subheading">{subheading}</h5>}
                            <h2>
                                {title} <br />
                                <span className="redfont">{highlight}</span>
                            </h2>
                            {tagline && <h4>{tagline}</h4>}

                            {description.map((para, index) => (
                                <p key={index}>{para}</p>
                            ))}


                            <div className="intro_learnmore">
                                <CustomButton href={buttonLink} text={buttonText} />
                            </div>
                        </div>
                    </div>

                    {/* Right Image */}
                    <div className="mygrid-col-lg-6 mygrid-col-xs-12 mygrid-col-md-12">
                        <div className="intro-image-wrapper">
                            {!isPlaying ? (
                                <>
                                    <img
                                        src={introImage}
                                        alt="Introduction"
                                        className="intro-image"
                                    />
                                    <img
                                        src={videoIcon}
                                        alt="Play Video"
                                        className="video-icon"
                                        onClick={handleVideoClick}
                                    />
                                </>
                            ) : (
                                <video
                                    ref={videoRef}
                                    className="intro-video"
                                    src={videoSrc}
                                    poster={introImage}
                                    controls
                                    autoPlay
                                    muted={false}
                                    playsInline
                                >
                                    Your browser does not support the video tag.
                                </video>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </VideoSectionContainer>
    );
};

export default VideoSection;
